import api from "../utils/api";

const BASE = "/api/admin/shops";

export async function getShops(params = {}) {
  return (
    await api.get(BASE, {
      params,
    })
  ).data;
}

export async function getShop(id) {
  return (
    await api.get(`${BASE}/${id}`)
  ).data;
}

export async function createShop(payload) {
  return (
    await api.post(BASE, payload)
  ).data;
}

export async function updateShop(id, payload) {
  return (
    await api.put(`${BASE}/${id}`, payload)
  ).data;
}

export async function deleteShop(id) {
  return (
    await api.delete(`${BASE}/${id}`)
  ).data;
}

export async function generateShopApiKey(
  id,
  payload = {},
) {
  return (
    await api.post(
      `${BASE}/${id}/api-keys`,
      payload,
    )
  ).data;
}